import { dateValueGetter, formatLongPrice, formatMillions, formatPrice, headerInfoTooltipDef } from '../../lib/utils';
import { DateTime } from 'luxon';

export const IPO = [
  {
    cellClass: 'ticker-cell',
    field: 'date',
    headerName: 'Expected IPO Date',
    ...headerInfoTooltipDef(
      'Date set during underwriting process for security to be acquired by the public market for the first time.',
    ),
    valueFormatter: ({ value }: any) => DateTime.fromISO(value).toFormat('MM/dd/yyyy'),
    valueGetter: ({ data }: any) => dateValueGetter(data.date),
    width: 140,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    field: 'ticker',
    width: 60,
    ...headerInfoTooltipDef('Symbol associated with the company'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellRendererParams: {
      tickerLogoVisible: true,
    },
    cellStyle: { fontWeight: 'bold' },
    field: 'name',
    width: 200,
  },
  {
    cellClass: 'ticker-cell',
    field: 'price_min',
    headerName: 'Price Min',
    ...headerInfoTooltipDef(
      'Range is determined on Offering Value and Offering shares. Determination: (Offering Value / Offering Shares).',
    ),
    valueFormatter: ({ value }: any) => formatPrice(value),
    valueGetter: ({ data }: any) => Number(Number(data.price_min).toLocaleString('en')),
    width: 100,
  },
  {
    cellClass: 'ticker-cell',
    field: 'price_max',
    headerName: 'Price Max',
    ...headerInfoTooltipDef(
      'Range is determined on Offering Value and Offering shares. Determination: (Offering Value / Offering Shares).',
    ),
    valueFormatter: ({ value }: any) => formatPrice(value),
    valueGetter: ({ data }: any) => Number(Number(data.price_max).toLocaleString('en')),
    width: 100,
  },
  {
    cellClass: 'ticker-cell',
    field: 'offering_value',
    headerName: 'Offering Value',
    ...headerInfoTooltipDef('The amount of capital that the company is looking to raise.'),
    valueFormatter: ({ value }: any) => formatMillions(value, true),
    width: 120,
  },
  {
    cellClass: 'ticker-cell',
    field: 'offering_shares',
    headerName: 'Offering Shares',
    ...headerInfoTooltipDef(
      'Number of shares available at public offering, which is typically determined after Offering Value is set.',
    ),
    valueFormatter: ({ value }: any) => formatLongPrice(value, ''),
    width: 140,
  },
];
